import {
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Alert,
  Spinner,
} from "design-react-kit";

const ConfirmDeleteModal = ({
  confirmModalOpen,
  confirmModalCloseHandler,
  text,
  flowId,
  target,
  error,
  isLoading,
  actionHandler,
  confirmButtonText,
}) => {
  return (
    <Modal
      isOpen={confirmModalOpen}
      toggle={confirmModalCloseHandler}
      align="center"
      scrollable
      labelledBy="confirmDelete"
    >
      <ModalHeader
        toggle={confirmModalCloseHandler}
        id="confirmDelete"
      ></ModalHeader>
      <ModalBody className="text-center">
        <div className="mb-3">
          <Icon icon="it-info-circle" fill="#D70049" />
          <h5 className="d-inline font-weight-bold ml-2">Attenzione!</h5>
        </div>
        {error !== null && error.length !== undefined && (
          <Alert color="danger">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <div className="position-relative upload-spinner">
            <p style={{ height: "50px", marginBottom: "7rem" }}>
              <Spinner double active />
            </p>
          </div>
        )}
        <p className="mb-2 font-weight-normal">{text}</p>
        <p className="font-weight-bold mb-2">{target}</p>
        <p className="mb-3 font-weight-normal">
          L'azione è irreversibile, vuoi procedere comunque?
        </p>
        <div className="col-sm-12 mb-2 d-flex align-items-center justify-content-around">
          <Button
            color="white"
            className="mr-2"
            onClick={confirmModalCloseHandler}
            id="user-cancel"
          >
            Annulla
          </Button>
          <Button color="danger" onClick={(e) => actionHandler(flowId)}>
            {confirmButtonText}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmDeleteModal;
